import { OrderState, RequestState, ActivityState, Maybe } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass, NgIf } from '@angular/common';

import { OrderStatePipe } from '@iss/wo-common/pipes';

@Component({
  selector: 'wo-order-state',
  templateUrl: './order-state.component.html',
  styleUrls: [ './order-state.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    NgClass,
    NgIf,
    OrderStatePipe,
  ],
})
export class OrderStateComponent {
  @Input() public state: Maybe<OrderState | RequestState | ActivityState>;
  @Input() public extra: Maybe<string>;
  @Input() public small: Maybe<boolean>;

  public getCssClass(state: Maybe<OrderState | RequestState | ActivityState>): string {
    switch (state) {
      case RequestState.Rfq:
        return 'wo-order-state--rfq';
      case RequestState.Quoted:
        return 'wo-order-state--quoted';
      case OrderState.Ordered:
        return 'wo-order-state--ordered';
      case RequestState.Rejected:
        return 'wo-order-state--rejected';
      case OrderState.ReadyForInvoicing:
        return 'wo-order-state--ready-for-invoicing';
      case OrderState.Invoiced:
        return 'wo-order-state--invoiced';
      case OrderState.Delivered:
      case OrderState.ClosedPurchasePart:
      case OrderState.ClosedSalesPart:
      case ActivityState.Active:
        return 'wo-order-state--accepted';
      case OrderState.ClosedAll:
        return 'wo-order-state--closed-all';
      default:
        return '';
    }
  }
}
